// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DataIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Data/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.667 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM16.667 5.208a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM16.667 18.542a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM3.333 11.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.833 10.625a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625H9.792V5.833c0-1.316.558-1.875 1.875-1.875h4.166a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625h-4.166c-2.017 0-3.125 1.109-3.125 3.125v3.542H4.167a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625h4.375v3.542c0 2.016 1.108 3.125 3.125 3.125h4.166a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625h-4.166c-1.317 0-1.875-.559-1.875-1.875v-3.542h6.041Z"
}));
export default DataIcon;